export const baseURL = 'https://ateliernicolascerrutti.com';
// export const baseURL = 'http://145.223.118.2:3131';
// export const baseURL = 'http://localhost:3131';
export const JWT_MAX_AGE_7_DAYS = 60 * 60 * 24 * 7;
